import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

//Utils
import events from '../../../../lib/events.js';

//Components
import ReportDropDown from '../components/reportDropDown.jsx';
import PrintableFullReport from '../components/printableFullReport.jsx';
import Loader from '../../../components/loader.jsx';
import Pagination from '../../../components/layout/pagination.jsx';

//Apis
import ReportApi from '../../../../api/report.jsx';

import {customerEmailPreferenceOptionsNames} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

const filterOptions = {
  branch: -1,
  branchOptions: [
    {
      value: -1,
      label: 'All Stores',
    },
  ],
  emailsTypesOptions: [
    {
      value: -1,
      label: 'All Emails',
    },
  ],
};

let optedOut;
let optedIn;
const tableMaxRows = 20;

class OptOutEmails extends React.Component {
  constructor(props) {
    super(props);

    let {formatMessage} = this.props.intl;

    optedOut = formatMessage({id: 'general.email.opted.out'});
    optedIn = formatMessage({id: 'general.email.opted.in'});

    const _filterOptions = Object.assign({}, filterOptions);

    const branchesFilterable = this.props.branches.map(b => {
      return {
        value: b.id,
        label: b.name,
      };
    });

    _filterOptions.branchOptions = [
      {
        value: -1,
        label: formatMessage({id: 'general.all.stores'}),
      }, ...branchesFilterable];

    _filterOptions.emailsTypesOptions = [
      {
        value: -1,
        label: formatMessage({id: 'general.all.emails'}),
      }];

    let cepon = customerEmailPreferenceOptionsNames(formatMessage);

    //Populate email filters
    for (var key in cepon) {
      if (cepon.hasOwnProperty(key)) {
        _filterOptions.emailsTypesOptions.push({
          value: key, label: cepon[key],
        });
      }
    }


    this.state = {
      loaded: true,
      report: null,
      fullReport: null,
      branches: this.props.branches.map(b => b.id),
      showNoDataMessage: false,
      emailType: -1,
      ..._filterOptions,
      count: 0,
      total: 0,
      page: 1,
    };
  }

  componentWillUnmount() {
    this.setState({
      filterOptions: {},
    });
  }

  onPageChange = (page, event) => {
    const {count, fullReport} = this.state;
    const pagReport = _.take(_.drop(fullReport, (page - 1) * count), count);

    this.setState({
      report: pagReport,
      page: page,
    });
  };

  detailedView() {
    const {report, page, count, total} = this.state;

    return (
      <div className='pad-top'>
        <table className='table-biolab table-striped optout-emails-table'>
          <thead style={{fontSize: '13px'}}>
            <tr>
              <th style={{width: '175px'}}><FormattedMessage id='general.primary.contact' /></th>
              <th>ALEX® Pro<br/><FormattedMessage id='customer.water.test.emails' /></th>
              <th><FormattedMessage id='customer.latest.from' /><br/>BioGuard®</th>
              <th><FormattedMessage id='customer.news.from' /><br/><FormattedMessage id='customer.pool.spa' /></th>
              <th><FormattedMessage id='customer.stop.receiving' /><br/><FormattedMessage id='general.all.emails' /></th>
            </tr>
          </thead>
          <tbody>
            {
              report.map(row => {
                let customerLink = `#customer/${row.CustomerID}`;

                return (
                  <tr key={row.CustomerID}>
                    <td>
                      <a href={customerLink}>{row.ContactName}</a>
                    </td>
                    <td>{row.AccountUpdate === false ? optedOut : optedIn}</td>
                    <td>{row.LatestFromBioguard === false ? optedOut : optedIn}</td>
                    <td>{row.NewsFromExpert === false ? optedOut : optedIn}</td>
                    <td>{row.AccountUpdate === false && row.LatestFromBioguard === false && row.NewsFromExpert === false ? optedIn : optedOut}</td>
                  </tr>);
              })
            }
          </tbody>
        </table>
        <div className='center-pagination'>
          <Pagination
            onPageChange={this.onPageChange}
            page={page}
            count={count}
            total={total} />
        </div>
      </div>
    );
  }

  exportReport = () => {
    const {intl} = this.props;
    const {branch, branches, emailType} = this.state;

    ReportApi.getOptOutEmailsReportExport(
      intl.locale,
      branch === -1 ? branches : branch,
      emailType);
  };

  printReport = () => {
    const {report, start, end, summary} = this.state;
    let {formatMessage} = this.props.intl;

    const tableColumns = [
      {name: formatMessage({id: 'general.primary.contact'}), key: 'ContactName'},
      {name: formatMessage({id: 'customer.alexpro.water.emails'}), key: 'AccountUpdateText'},
      {name: formatMessage({id: 'customer.emailprefs.latest.bioguard'}), key: 'LatestFromBioguardText'},
      {name: formatMessage({id: 'customer.emailprefs.news'}), key: 'NewsFromExpertText'},
      {name: formatMessage({id: 'reports.optout.stop.recieving'}), key: 'StopReceiving'},
    ];


    report.forEach(function(element) {
      element.AccountUpdateText = element.AccountUpdate === false ? optedOut : optedIn;
      element.LatestFromBioguardText = element.LatestFromBioguard === false ? optedOut : optedIn;
      element.NewsFromExpertText = element.NewsFromExpert === false ? optedOut : optedIn;
      element.StopReceiving = element.AccountUpdate === false && element.LatestFromBioguard === false && element.NewsFromExpert === false ? optedIn : optedOut;
    }, this);

    return (
      <PrintableFullReport
        tableColumns={tableColumns}
        tableData={report}
        title={formatMessage({id: 'reports.optout.emails.summary'})}
        formatMessage={formatMessage}
      />
    );
  };

  resetFilters = () => {
    this.setState({
      branch: -1,
      emailType: -1,
    });
  };

  updateReport = () => {
    const {branch, branches, emailType} = this.state;

    this.setState({
      loaded: false,
    });

    ReportApi.getOptOutEmailsReport(
      branch === -1 ? branches : branch,
      emailType)
      .then(data => {
        if(data && data.report) {
          this.setState({
            fullReport: data.report,
            report: _.take(data.report, 20),
            total: data.report.length,
            count: 20,
            page: 1,
            showNoDataMessage: !data.report.length,
          });
        } else {
          this.setState({showNoDataMessage: true});
        }
      }).catch(err => {
        console.log(err);
        this.setState({showNoDataMessage: true});
      }).complete(() => {
        this.setState({
          loaded: true,
        });
      });
  };

  render() {
    const {loaded, branch, branchOptions, emailType, emailsTypesOptions, report, showNoDataMessage} = this.state;
    let {formatMessage} = this.props.intl;

    return (
      <div className='report-container'>
        <span className='description'><FormattedMessage id='reports.optout.description' /></span>
        <div className='report-options'>
          <div className='top-title-bar'>
            <FormattedMessage id='general.report.options' />
          </div>
          <div className='select-options container-fluid'>
            <div className='row'>
              <div className='col-sm-3'>
                <ReportDropDown value={branch} label={formatMessage({id: 'general.store'})}
                  onChange={((e) => {
                    this.setState({branch: parseInt(e.target.value)});
                  })}
                  options={branchOptions} />
              </div>
              <div className='col-sm-3'>
                <ReportDropDown value={emailType} label={formatMessage({id: 'general.email.type'})}
                  onChange={((e) => {
                    this.setState({emailType: parseInt(e.target.value)});
                  })}
                  options={emailsTypesOptions} />
              </div>
            </div>
          </div>
          <div className='manage-options'>
            <div className='col-sm-12 button-group'>
              <span className='reset-button pull-right' onClick={this.resetFilters}><FormattedMessage id='general.reset' /></span>
              <button className='btn btn-primary pull-right' onClick={this.updateReport}><FormattedMessage id='reports.update.summary' /></button>
            </div>
          </div>
        </div>
        <Loader loaded={loaded}>
          <div className='col-sm-12 summary-container'>
            <h2><FormattedMessage id='reports.report.summary' /></h2>
            <p><FormattedMessage id='reports.reveal.report.summary' /></p>
            {showNoDataMessage ? <label className='report-no-data'><FormattedMessage id='reports.error.no.results' /></label> : ''}
            { report && report.length > 0 ? this.detailedView() :  <div className='pad-top' />}
          </div>
        </Loader>
        <div className='col-sm-12 button-group shift-right'>
          <button className='btn btn-default pull-right' disabled={(report === null || showNoDataMessage)} onClick={(() => {
            events.publish('print', this.printReport());
          })}><FormattedMessage id='reports.print.summary' />
          </button>
          <button className='btn btn-primary pull-right'
                  disabled={(report === null || showNoDataMessage)}
                  onClick={this.exportReport}><FormattedMessage id='reports.export.report' /></button>
        </div>
      </div>
    );
  }
}

OptOutEmails.propTypes = {
  branches: PropTypes.any,
};

OptOutEmails.defaultProps = {
  branches: [],
};

export default injectIntl(OptOutEmails);
